"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const mutation = (0, client_1.gql) `
mutation generateWaitListReport($eventId:String) {
    generateWaitListReport(eventId:$eventId) {
      url
    }
  }
`;
exports.default = mutation;
//# sourceMappingURL=waitListReport.mutation.js.map